.controlPanel {
  /**
   * Control panel needs to be positioned element so that is appears on top of
   * the AR canvas.
   */
  position: relative;

  padding: 0.5em;
  margin-left: auto;
  width: max-content;

  background-color: #a6a6a63c;
  backdrop-filter: blur(2px);
}
